import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionDriverTable extends Layout {
    sourceMCFilterJunctionDriver: DataSource;
    tableMCFilterJunctionDriver: Table;
}
